import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

export default function Portfolio({ color }) {
  const theme = useContext(ThemeContext);
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.5 3.5C4.39543 3.5 3.5 4.39543 3.5 5.5V9.5C3.5 10.6046 4.39543 11.5 5.5 11.5H9.5C10.6046 11.5 11.5 10.6046 11.5 9.5V5.5C11.5 4.39543 10.6046 3.5 9.5 3.5H5.5ZM5.5 12.5C4.39543 12.5 3.5 13.3954 3.5 14.5V18.5C3.5 19.6046 4.39543 20.5 5.5 20.5H9.5C10.6046 20.5 11.5 19.6046 11.5 18.5V14.5C11.5 13.3954 10.6046 12.5 9.5 12.5H5.5ZM12.5 5.5C12.5 4.39543 13.3954 3.5 14.5 3.5H18.5C19.6046 3.5 20.5 4.39543 20.5 5.5V9.5C20.5 10.6046 19.6046 11.5 18.5 11.5H14.5C13.3954 11.5 12.5 10.6046 12.5 9.5V5.5ZM14.5 12.5C13.3954 12.5 12.5 13.3954 12.5 14.5V18.5C12.5 19.6046 13.3954 20.5 14.5 20.5H18.5C19.6046 20.5 20.5 19.6046 20.5 18.5V14.5C20.5 13.3954 19.6046 12.5 18.5 12.5H14.5Z'
        fill={color ? theme.palette[color] : theme.dim['60_white']}
      />
    </svg>
  );
}
